import "./TransportsListing.css";
import { Fragment } from "react";
import { Link } from "react-router-dom";
import { PulseLoader } from "react-spinners";
import NoDataFound from "../../../../Components/NoDataFound/NoDataFound";
import TransportListingViewModel from "./TransportsListingViewModel";
const TransportsListing = () => {
  const { TransportsArray, AuthUser, IsLoading } = TransportListingViewModel();
  return (
    <Fragment>
      {/* Page Wrapper */}
      <div className="page-wrapper admin-add-transport-page">
        <div className="content container-fluid">
          {/* Page Header */}
          <div className="page-header">
            <div className="row align-items-center">
              <div className="col">
                <h3 className="page-title">Transport</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to={`/user/${AuthUser?.UserType}/dashboard`}>
                      Dashboard
                    </Link>
                  </li>
                  <li className="breadcrumb-item active">Transport</li>
                </ul>
              </div>
            </div>
          </div>
          {/* /Page Header */}
          <div className="row">
            <div className="col-sm-12">
              <div className="card card-table">
                <div className="card-body">
                  {/* Page Header */}
                  <div className="page-header">
                    <div className="row align-items-center">
                      <div className="col">
                        <h3 className="page-title">Transport</h3>
                      </div>
                    </div>
                  </div>
                  {/* /Page Header */}
                  {IsLoading ? (
                    <PulseLoader
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                      color="#3D5EE1"
                      size={16}
                    />
                  ) : (
                    <div className="table-responsive">
                      <table className="table border-0 star-student table-hover table-center mb-0 datatable table-striped">
                        <thead className="student-thread">
                          <tr>
                            <th>Route Name</th>
                            <th>Vehicle Number</th>
                            <th>Driver Name</th>
                            <th>Driver License</th>
                            <th>Contact Number</th>
                            <th>Driver Address</th>
                          </tr>
                        </thead>
                        <tbody>
                          {TransportsArray &&
                            TransportsArray.map((item, index) => {
                              return (
                                <tr key={index}>
                                  <td>{item?.RouteName}</td>
                                  <td>{item?.VehicleNumber}</td>
                                  <td>{item?.DriverName}</td>
                                  <td>{item?.DriverLicense}</td>
                                  <td>{item?.ContactNumber}</td>
                                  <td>{item?.DriverAddress}</td>
                                </tr>
                              );
                            })}
                        </tbody>
                      </table>
                      {TransportsArray?.length <= 0 && <NoDataFound />}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Page Wrapper */}
    </Fragment>
  );
};

export default TransportsListing;
